export default __webpack_public_path__ + "static/N0099-60dbf0471e315fa47c354007501a4fe5.png";